import type {
  BookkeepingFeatureOptions,
  BookkeepingPlatformSelectionDialogViewModelFactory,
} from '@/features/bookkeeping'
import { BookkeepingPlatformConnectionStore } from '@/features/bookkeeping/platform-connections/BookkeepingPlatformConnectionStore'
import { BookkeepingApi } from '@/features/bookkeeping/api/bookkeeping-api'
import Env from '@/infra/env'
import { BookkeepingPlatformSelectionDialogViewModel } from '@/features/bookkeeping/components/BookkeepingPlatformSelectionDialog/BookkeepingPlatformSelectionDialogViewModel'

export function InternalBookkeepingFeature(options: BookkeepingFeatureOptions) {
  const api = new BookkeepingApi({
    token$: options.token$,
    baseURL: Env.WORK_DOTNET_API,
  })

  const bookkeepingPlatformConnectionStore =
    new BookkeepingPlatformConnectionStore(api)

  const createBookkeepingPlatformSelectionDialogViewModel: BookkeepingPlatformSelectionDialogViewModelFactory =
    (vmOptions) => {
      return new BookkeepingPlatformSelectionDialogViewModel(
        vmOptions,
        bookkeepingPlatformConnectionStore,
        options.getCurrentMember,
        options.createSnackbarRetryWrapper,
        options.newSnackbar,
      )
    }

  return {
    bookkeepingPlatformConnectionStore,
    createBookkeepingPlatformSelectionDialogViewModel,
  }
}
